import { getLocale } from "../runtime";

const sv_hucountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Hungary`
};

const hucountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_hucountryenglish(inputs)
	return "huCountryEnglish";
};

export { hucountryenglish as "huCountryEnglish" };